import { FC } from 'react';
import BaseTemplate from '../BaseTemplate';
import { Container } from 'react-bootstrap';
import { Button, Label } from '../../atoms';
import cn from 'classnames';
import styles from './OrganizationTextBlockAddTemplate.module.css';
import { OrganizationTextBlockOrganism } from '../../organisms';
import { useNavigate, useParams } from 'react-router-dom';
import { RichTextBlockResponseDto } from '../../../store/buyerAPI/block/dto/response/rich-text-block-response.dto';

export interface OrganizationTextBlockAddTemplateProps {
  handleOnChange: (textBlock: RichTextBlockResponseDto) => void;
  textBlock: RichTextBlockResponseDto;
  callbackFn: (textBlock: RichTextBlockResponseDto) => void;
}

const OrganizationTextBlockAddTemplate: FC<
  OrganizationTextBlockAddTemplateProps
> = ({ handleOnChange, textBlock, callbackFn }) => {
  const { organizationId } = useParams();
  const navigate = useNavigate();
  return (
    <BaseTemplate>
      <Container>
        <div className={cn(styles.heading)}>
          <Label content="Create Text Block" size="lg" />
          <Button
            className={styles.buttonLink}
            onClick={() =>
              navigate(`/organizations/edit/${organizationId}/content-blocks`)
            }
            variant="link"
          >
            Go back
          </Button>
        </div>
        <OrganizationTextBlockOrganism
          handleOnChange={handleOnChange}
          textBlock={textBlock}
          callbackFn={callbackFn}
        />
      </Container>
    </BaseTemplate>
  );
};

export default OrganizationTextBlockAddTemplate;
